module.exports = __webpack_public_path__ + "img/EmptyState_noitem.272715bf.svg";